import { ZendeskWrapper } from '@/utils/zendeskWrapper'
import { PendoWrapper } from '@/utils/pendoWrapper'
import { ChatbotWrapper } from '@/utils/ChatbotWrapper'
import { store } from '../store'

class InternalThirdPartyToolsManager {
  constructor () {
    this.initialized = false
    this.userData = null
    this.appSettings = null
    this.ZendeskWrapper = ZendeskWrapper
    this.accessToken = null
    this.PendoWrapper = PendoWrapper
    this.ChatbotWrapper = ChatbotWrapper
    this.pendoTimer = null
  }

  async init ({ appSettings, userData, impersonatedUser, loggedInUser, accessToken }) {
    if (userData && appSettings &&
      impersonatedUser && impersonatedUser._userId !== 0 &&
      loggedInUser && loggedInUser._userId !== 0) {
      this.appSettings = appSettings
      this.userData = userData
      this.impersonatedUser = impersonatedUser
      this.loggedInUser = loggedInUser
      this.accessToken = accessToken
      this.initialized = true
      this._initializePendo()
    } else {
      console.warn('[ThirdPartyToolsManager]: please provide userData')
    }
  }

  routeTo (routeName, requiresAuth) {
    if (this._shouldEnableZendesk) this.ZendeskWrapper.determineVisibility(routeName)
    if (window.pendo && window.pendo.areGuidesDisabled && window.pendo.areGuidesDisabled() && !this._shouldDisableGuides && requiresAuth) {
      this.PendoWrapper.enableGuides()
    }
  }

  enableSfChat () {
    const { isPoweredBySubAccountUser } = store.getters['user/getExternalIdInfo']
    if (this._shouldEnableSfChat && !isPoweredBySubAccountUser) this._initializeSalesforceChat()
  }

  async attemptPendoUserDataSync () {
    if (this.PendoWrapper && this.PendoWrapper.updateUserData) {
      await store.dispatch('user/getAdditionalUserData', {})
      const impersonatedUserData = store.state.user.impersonatedUser
      const loggedInUserData = store.state.user.loggedInUser

      if (impersonatedUserData && loggedInUserData) {
        this.PendoWrapper.updateUserData(impersonatedUserData, loggedInUserData)
      }
    }
  }

  async _initializePendo () {
    if (this._shouldEnablePendo) {
      this.PendoWrapper.init(this.impersonatedUser, this.loggedInUser, this._shouldDisableGuides)
      await this.attemptPendoUserDataSync()
    }
  }

  async _initializeSalesforceChat () {
    this.ChatbotWrapper.init(this.loggedInUser, this.accessToken)
  }

  disablePendoGuides () {
    this.PendoWrapper.disableGuides()
  }

  enablePendoGuides () {
    if (this.isPoweredBySubAccountUser()) return
    this.PendoWrapper.enableGuides()
  }

  isPoweredBySubAccountUser () {
    const { isPoweredBySubAccountUser } = store.getters['user/getExternalIdInfo']
    return isPoweredBySubAccountUser
  }

  get _shouldEnablePendo () {
    const appSettings = this.appSettings
    const featureFlag = appSettings && appSettings.globalSettings && appSettings.globalSettings.enablePendo
    if (!featureFlag) return false
    const userData = this.userData
    const isImpersonatingUser = userData.id !== userData.impersonatedUserId
    return !userData.isAdmin || (userData.isAdmin && !isImpersonatingUser)
  }

  get _shouldEnableSfChat () {
    const appSettings = this.appSettings
    const featureFlag = appSettings && appSettings.featureFlags && appSettings.featureFlags.DisplaySFChat
    return !!featureFlag
  }

  get _shouldEnableZendesk () {
    const userData = this.userData
    return userData && (userData.HasShippedAnOrder && !userData.IsDemoUser)
  }

  get _shouldDisableGuides () {
    const onboardingShown = store.getters['onboarding/onboardingShown']
    const onboardingCompleted = store.getters['onboarding/completed']
    return this.isPoweredBySubAccountUser() || (onboardingShown && !onboardingCompleted)
  }
}

export const ThirdPartyToolsManager = new InternalThirdPartyToolsManager()
